var map = {
	"./first-screenshot-mob.png": "fe40",
	"./first-screenshot.png": "d52b",
	"./second-screenshot-mob.png": "f061",
	"./second-screenshot.png": "2c2c",
	"./third-screenshot-mob.png": "680a",
	"./third-screenshot.png": "b5b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f2e";